import { useUserActiveOrganization, useStandingOffers } from "@/api";
import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { Eye, EyeOff, Plus } from "lucide-react";
import { useState } from "react";
import { useStandingOfferTableData } from "../../hooks/useStandingOfferTableData";
import { StandingOffersTable } from "./StandingOffersTable";

export function StandingOffers() {
  const [filterCancelled, setFilterCancelled] = useState(false);
  const { activeOrganization } = useUserActiveOrganization();

  const { data, loading, error } = useStandingOffers();

  const standingOffersData = useStandingOfferTableData(data, filterCancelled);

  return (
    <div>
      <div className="flex justify-end items-center gap-3 mb-6 mt-3 w-full">
        <TypographySM className="w-full text-brand-gray-800 dark:text-brand-gray-200">
          Standing offers allow anyone to access your app through a shared URL.
        </TypographySM>
        <Button
          variant="ghost"
          onClick={() => setFilterCancelled((prev) => !prev)}
          className="text-xs"
          data-testid="filterCancelled"
        >
          {filterCancelled ? (
            <EyeOff className="mr-2 h-4 w-4" />
          ) : (
            <Eye className="mr-2 h-4 w-4" />
          )}
          Filter cancelled
        </Button>
        <Link
          to="/organization/$organizationSlug/subscriptions/create-standing-offer"
          params={{ organizationSlug: activeOrganization?.slug || "" }}
        >
          <Button variant="outline">
            <Plus className="mr-2 h-4 w-4" />
            Create standing offer
          </Button>
        </Link>
      </div>
      <StandingOffersTable
        data={standingOffersData}
        loading={loading}
        error={error}
      />
    </div>
  );
}
